export default {
  GET_PTO_FOR_GOOD_LIST: state => state.ptoForGoodList,
  GET_PTO_FOR_GOOD_ONE: state => state.ptoForGoodOne,
}
